import store from '@/store/'
import { TransactionsPriceSummary } from '@/interfaces/report/transactions'
import { getNestedValue } from '@/util/helpers'

const headline = (transactionsKey: string): string => {
  switch (transactionsKey) {
    case 'firstSaleTransactions':
      return 'Transakce prvoprodej'
    case 'offeredTransactions':
      return 'Transakce ceník developerů'
    case 'resellTransactions':
      return 'Transakce přeprodej'
    default:
      return 'Transakce'
  }
}

export function transactionGroupsSummaries(
  dataSet: any = {}
): TransactionsPriceSummary[] {
  return Object.keys(dataSet).map(transactionsKey => ({
    headline: headline(transactionsKey),
    priceTotal: getNestedValue(
      dataSet,
      [transactionsKey, 'valuation', 'total'],
      0
    ),
    priceSquare: getNestedValue(
      dataSet,
      [transactionsKey, 'valuation', 'm2'],
      0
    ),
    transactionsKey,
    disabled: transactionGroupDisabled(transactionsKey),
    excluded: getNestedValue(dataSet, [transactionsKey, 'excluded'], false),
  }))
}

export function transactionGroupDisabled(transactionsKey: string): boolean {
  const groupEdit = getNestedValue(
    store.getters['valuationEdit/edits'],
    ['transactionGroups', transactionsKey],
    undefined
  )
  const disabled = getNestedValue(
    store.getters['valuationEdit/data'],
    ['transactionData', transactionsKey, 'disabled'],
    false
  )

  if (groupEdit !== undefined) {
    return !groupEdit
  }

  return disabled
}
